<template lang="pug">
  .component-selectize-driver

    selectize(v-if="options",
      :disabled="disabled",
      :selectedValue="selectedValue",
      :options="options",
      value-field="id",
      :maxItems="maxItems" label-field="name",
      :items="items" :searchField="searchableFields",
      :optionTemplate="optionTemplate",
      :renderTemplate="renderTemplate",
      @itemAdded="optionSelected",
      @itemRemoved="optionRemoved",
      placeholder="Parking lot")
</template>

<script>
  import Selectize from '../../../Selectize'
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'

  export default {
    name: 'SelectizeParkingLot',
    extends: BaseSelectize,
    components: {Selectize},
    data() {

      return {
        searchableFields: ['id', 'name']
      }
    },
    created() {
      KeplerBackofficeSdk.parkingLots.list.all((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div>PL${item.id} - ${item.name}</div></div>`
      },
      renderTemplate(item, escape) {
        return `<div><div>PL${item.id} - ${item.name}</div></div>`
      },
      optionSelected(option) {
        this.$emit('optionSelected', option)
        this.$emit('input', option.id)
      },
    },
    props: {

      selectedValue: {}
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeParkingLot.vue?78fb9b70